import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { deserialize } from 'santee-dcts';
import { Settings } from '../../core';
import { SponsorProtocolAccessReport, SponsorProtocolAccessReportReadModel } from './report-types/sponsor-protocol-access-report';
import { defaultProtocolAccessesSort } from '../../documents/models/default-report-sort';

@Injectable()
export class SponsorProtocolAccessessStorage {
    constructor(
        private http: HttpClient,
        private settings: Settings
    ) { }

    public getReports(protocolId: number): Observable<SponsorProtocolAccessReport[]> {
        return this.http.get(`${this.settings.apiUrl}/sponsor/study/${encodeURI(protocolId.toString())}/activity-reports/protocol-accesses`)
            .pipe(
                map((reports) => {
                    let protocolAccesses = deserialize(reports, SponsorProtocolAccessReportReadModel).reports;
                    protocolAccesses = protocolAccesses.sort((a, b) => defaultProtocolAccessesSort(a, b));
                    return protocolAccesses;
                }),
            );
    }
}
